import NavigationMobile from './NavigationMobile.vue'

export default NavigationMobile
